<template>
  <div class="squawk-table-container">
    <table>
      <thead>
        <tr class="header">
          <th>Tail Number</th>
          <th>Status</th>
          <th>Submitted By</th>
          <th>Date Submitted</th>
          <th>View</th>
          <th v-if="canUpdate">Update</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="2">{{ aircraft.tailNumber }}</td>
          <td rowspan="2">{{ squawk.squawkStatus?.name || "-" }}</td>
          <td rowspan="2">{{ $global.getFullName(squawk.creationUser) }}</td>
          <td rowspan="2">{{ $global.formatDate(squawk.creationDate) }}</td>
          <td rowspan="2">
            <a
              href="#"
              class="link"
              @click="$emit('showSquawkModal', { aircraft, squawk }, 'isView')"
              >View</a
            >
          </td>
          <td rowspan="2" v-if="canUpdate">
            <a
              href="#"
              class="link"
              @click="$emit('showSquawkModal', { aircraft, squawk }, 'isEdit')"
            >
              Update
            </a>
          </td>
        </tr>
        <tr></tr>
        <tr>
          <!-- <td colspan="1"></td> -->
          <td colspan="1" class="highlight">Submission</td>
          <td colspan="5"></td>
        </tr>
        <tr>
          <td colspan="6" :title="squawk.description">
            {{ squawk.description }}
          </td>
        </tr>
        <tr>
          <td colspan="1" class="highlight">Maintenance Notes</td>
          <td colspan="5"></td>
        </tr>
        <tr>
          <td colspan="6" :title="squawk.response">
            {{ this.squawk.response ? this.squawk.response : "-" }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    squawk: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    aircraft: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    canUpdateSquawks() {
      return ["Admin", "Maintenance"].includes(
        this.$store.getUser.userType?.name,
      );
    },
    canUpdate() {
      const { userType } = this.$store.getUser;
      const maintenanceCondition =
        this.squawk.approvalDate !== null
          && this.squawk.priority !== null
          && this.squawk.squawkStatusId !== null
          && this.squawk.squawkStatus?.name === "Completed";

      return this.canUpdateSquawks && (userType.name === 'Admin' ? true : maintenanceCondition);
    },
  },
};
</script>
<style scoped>
.squawk-table-container {
  width: 100%;
}
.squawk-table-container table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.squawk-table-container th,
td {
  border: 1px solid #ddd;
  padding: 5px 12px;
  text-align: left;
  font-size: 14px;
}
.squawk-table-container th {
  background-color: #a148ad;
  color: white;
  font-weight: normal;
  border: none;
  text-align: left;
}
.squawk-table-container .header {
  background-color: #a148ad;
  color: white;
  font-weight: bold;
}
.squawk-table-container .highlight {
  background-color: #f8f8f8;
  font-weight: bold;
  width: fit-content;
}
.squawk-table-container .link {
  color: #3c78ff;
  text-decoration: none;
}
</style>
